<div class="audit-list-container" style="padding-bottom: var(--footer-height, 56px); box-sizing: border-box;">
  <div class="flex justify-content-end mt-3">
    <div>
      <div class="total">
        Total Product Family({{ productFamilyTotalRecords }})
      </div>
    </div>
    <div class="filter-action-row">
      <button pButton type="button" label="Save" class="" (click)="Add()">
        Add
      </button>
    </div>
  </div>
  <app-table
    [data]="productFamilyData"
    [columns]="productFamilyColumns"
    [rows]="productFamilyPageSize"
    [showPaginator]="true"
    [showSort]="false"
    [showFilter]="false"
    [loading]="productFamilyLoading"
    [globalFilterFields]="productFamilyGlobalFilterFields"
    [actions]="productFamilyActions"
    [totalRecords]="productFamilyTotalRecords"
    [hideTableHeader]="true"
    (lazyLoadData)="onLazyLoadEventFromTable($event)"
  >
  </app-table>
</div>

<app-add-product-family
  [visible]="openModal"
  [data]="editData"
  (closeDialog)="closeDialog($event)"
  [editMode]="editMode"
></app-add-product-family>
